export const timeFormatter = (value: string) => {
  const maskTail = [':', /[0-5]/, /\d/];

  if (Number(value[0]) > 2) {
    return [/\d/, ...maskTail];
  }
  if (value.startsWith('2') && Number(value[1]) > 3 || value[1] === ':') {
    return [/\d/, ...maskTail];
  }

  return [/[012]/, /\d/, ...maskTail];
}
